import React, { useState, useCallback } from 'react';
import {
  Form, Input, Select, Switch, Typography,
} from 'antd';
import { LoadingImage } from 'components';
import MicroRequiredIndicator from 'components/MicroRequiredIndicator/MicroRequiredIndicator';
import { productProperties } from 'config/language';
import { PRODUCT_TYPE_OPTIONS } from 'config/tags';
import ArtistSelectField from './ArtistSelect/index';
import SkuSummary from './SkuSummary';

const { TextArea } = Input;

const { Option } = Select;

const { Title, Text } = Typography;

const PLACEHOLDER_IMAGE = 'data:image/png;base64,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';

const About = ({
  form,
  tapBadgeImageUrl,
  onNameChange,
  canEdit,
}) => {
  const webRenderUrl = Form.useWatch('webRenderUrl', form);

  const [abvIsRange, setAbvIsRange] = useState(
    form.getFieldValue('abvIsRange'),
  );

  const onChangeAbvIsRange = useCallback((value) => {
    setAbvIsRange(value);

    if (value) {
      form.setFieldValue('abv', null);
    } else {
      form.setFieldValue('abvMin', null);
      form.setFieldValue('abvMax', null);
    }
  }, []);

  const skus = form.getFieldValue('skus') || [];
  const productName = form.getFieldValue('name');
  const visibleSkus = skus.filter(
    (sku) => !sku.isLegacy && !sku.deleted,
  );

  return (
    <div className="about-tab-content">
      {(!!tapBadgeImageUrl || !!webRenderUrl) && (
        <div className="about-tab-artwork-previews">
          {!!tapBadgeImageUrl && (
            <div className="about-tab-artwork-preview">
              <Text type="secondary" className="about-tab-artwork-label">
                {productProperties.tapBadgeUrl.labels.field}
              </Text>
              <LoadingImage
                preview
                src={tapBadgeImageUrl || PLACEHOLDER_IMAGE}
                alt={productProperties.tapBadgeUrl.labels.field}
                fallback={PLACEHOLDER_IMAGE}
                width={150}
                height={150}
                shape="circle"
                notFoundContent={<div>no content</div>}
              />
            </div>
          )}
          {!!webRenderUrl && (
            <div className="about-tab-artwork-preview">
              <Text type="secondary" className="about-tab-artwork-label">
                {productProperties.webRenderUrl.labels.field}
              </Text>
              <LoadingImage
                preview
                src={webRenderUrl || PLACEHOLDER_IMAGE}
                alt={productProperties.webRenderUrl.labels.field}
                fallback={PLACEHOLDER_IMAGE}
                width={150}
                height={150}
                shape="square"
                notFoundContent={<div>no content</div>}
              />
            </div>
          )}
        </div>
      )}
      <Title level={5} className="about-tab-section-title">
        Beer info
      </Title>
      <div className="columns-container columns-container--wide">
        <div className="column">
          <Form.Item
            name="name"
            label={productProperties.name.labels.field}
            rules={[{ required: true, message: `${productProperties.name.labels.field} is required` }]}
            labelCol={{ span: 24 }}
          >
            <Input onChange={(event) => {
              onNameChange(event.target.value);
            }}
            />
          </Form.Item>
          <Form.Item
            label={productProperties.productType.labels.field}
            labelCol={{ span: 24 }}
            style={{ flex: 2 }}
          >
            <div className="about-tab-type-row">
              <Form.Item name="type" noStyle>
                <Select style={{ flex: 1, minWidth: 0 }}>
                  {PRODUCT_TYPE_OPTIONS.map(({ value, label }) => (
                    <Option key={value} value={value}>{label}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="requiresMicroReadings" valuePropName="checked" noStyle>
                <MicroRequiredIndicator disabled={!canEdit} />
              </Form.Item>
            </div>
          </Form.Item>

          <Form.Item
            label={(
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'start',
                alignItems: 'center',
                gap: 12,
              }}
              >
                <span>{productProperties.abv.labels.field}</span>
                <Form.Item
                  name="abvIsRange"
                  valuePropName="checked"
                  style={{
                    paddingBottom: 3,
                    marginBottom: 0,
                  }}
                >
                  <Switch
                    checkedChildren="Range"
                    unCheckedChildren="Range"
                    onChange={onChangeAbvIsRange}
                  />
                </Form.Item>
              </div>
            )}
            labelCol={{ span: 24 }}
            style={{ flex: 1 }}
          >
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 12,
            }}
            >
              {abvIsRange ? (
                <>
                  <Form.Item
                    name="abvMin"
                    style={{
                      paddingBottom: 0,
                      marginBottom: 0,
                    }}
                  >
                    <Input suffix="%" type="number" />
                  </Form.Item>
                  <span style={{
                    lineHeight: 1,
                  }}
                  >
                    -
                  </span>
                  <Form.Item
                    name="abvMax"
                    style={{
                      paddingBottom: 0,
                      marginBottom: 0,
                    }}
                  >
                    <Input suffix="%" type="number" />
                  </Form.Item>
                </>
              ) : (
                <Form.Item
                  name="abv"
                  style={{
                    paddingBottom: 0,
                    marginBottom: 0,
                  }}
                >
                  <Input suffix="%" type="number" />
                </Form.Item>
              )}
            </div>
          </Form.Item>
          <Form.Item
            name="oneLiner"
            label={productProperties.oneLiner.labels.field}
            labelCol={{ span: 24 }}
          >
            <TextArea
              autoSize={{ minRows: 2 }}
            />
          </Form.Item>
          <Form.Item
            name="blurb"
            label={productProperties.blurb.labels.field}
            labelCol={{ span: 24 }}
          >
            <TextArea
              autoSize={{ minRows: 4 }}
            />
          </Form.Item>
        </div>
        <div className="column">
          <ArtistSelectField fieldName="artist" />

          <Form.Item
            name="style"
            label={productProperties.style.labels.field}
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="dearSku"
            label={productProperties.dearSku.labels.field}
            className="half-width"
            labelCol={{ span: 24 }}
          >
            <Input />
          </Form.Item>
        </div>
      </div>

      <SkuSummary skus={visibleSkus} productName={productName} />

      {/* Hidden fields: preserve legacy product-level RRP values on save */}
      <Form.Item name="rrp" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item name="rrpAud" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
    </div>
  );
};

export default About;
